import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { APP_VERSION } from '../../../environments/version';
import { VersionService } from '../../release-notes/services/version.service';

@Component({
    selector: 'ceres-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {
    private readonly versions = inject(VersionService);
    private readonly destroyRef = inject(DestroyRef);
    currentYear = new Date().getFullYear();
    version = APP_VERSION.version;

    ngOnInit(): void {
        this.versions.version$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((version) => {
            this.version = version;
        });
    }
}
